
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';


export interface DialogData {
  btns: string;
  title: string;
  message: string;
  cnclBTn: boolean;
  dataList? : any;
  showUserList?:boolean
  showDropdown?:boolean
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent implements OnInit {

  dialogData: DialogData;
  title: string;
  message: string;
  btns = false;
  btnArr: string[] = [];
  dataSource : any[] = [];
  cnclBTn: boolean = false;
  selectedUser: any 
  displayedColumns: string[] = ['name', 'email', 'phoneMain'];
  selectedValue: any = null; 
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
    if(this.data.dataList){
      this.dataSource = this.data.dataList;
    }
    if (this.data.btns) {
      this.btns = true;
    }
    else {
      this.btns = false;
    }
    let btns = this.data.btns || 'Yes,No';
    this.btnArr = btns.split(',');
    this.cnclBTn = this.data.cnclBTn;

    if (this.data.showDropdown && this.data.dataList) {
      this.dataSource = this.data.dataList;
    }
  }

  // onConfirm(): void {
  //   if(this.data?.showUserList){
  //     if(this.selectedUser){
  //       console.log("selectedUser",this.selectedUser)
  //       this.dialogRef.close(this.selectedUser)
  //     }else{
  //       return 
  //     }
    
  //   }else{
  //     this.dialogRef.close(true);
  //   }
    
  // }


  onConfirm(): void {
    if (this.data.showDropdown) {
      if (!this.selectedValue) {
        return;
      }
      this.dialogRef.close(this.selectedValue);
    } else if (this.data?.showUserList) {
      if (this.selectedUser) {
        this.dialogRef.close(this.selectedUser);
      } else {
        return;
      }
    } else {
      this.dialogRef.close(true);
    }
  }
  onDismiss(): void {
    this.dialogRef.close(false);
  }

  onCancel() {
    this.dialogRef.close('cancel');
  }

  onBtn(btn:any): void {
    this.dialogRef.close(btn);
  }
}
